(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["knn-product-offer"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  document.querySelectorAll('[data-knn-offer]').forEach(function (root) {
    if (root.hasAttribute('data-require-tier-selection')) {
      root.querySelectorAll('[data-tier]').forEach(function (tier) {
        tier.checked = false;
        var label = tier.closest('label');
        if (label) label.classList.remove('is-selected');
      });
    }
    var atcBtn = root.querySelector('[data-knn-offer-atc]');
    root.querySelectorAll('[data-knn-card-atc]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = button.closest('.knn-quiz-card').querySelector('[data-tier]');
        if (!input || input.dataset.soldout === 'true') return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        var selected = getSelectedTier(root);
        if (selected) addToCart(selected, button, root);
      });
    });

    root.querySelectorAll('[data-mode-toggle]').forEach(function (input) {
      input.addEventListener('change', function () {
        setMode(root, this.value);
      });
    });

    root.querySelectorAll('[data-tier]').forEach(function (input) {
      input.addEventListener('change', function () {
        /* Clear is-selected from the same radio group, then mark this one.
           Works for any funnel: funnel 0 groups by per-mode name, funnel 6 by its
           single name, and the highlight lives on the closest <label>. */
        var name = input.name;
        root.querySelectorAll('[data-tier]').forEach(function (other) {
          if (other.name === name) {
            var lbl = other.closest('label');
            if (lbl) lbl.classList.remove('is-selected');
          }
        });
        var label = input.closest('label');
        if (label) label.classList.add('is-selected');

        updateMainPrice(input);
        updateGiftEligibility(root);
        updateSelectionButton(root);
        if (!root._knnFromGallery) updateGalleryMedia(input, true);
        syncOfferUrl(root);
      });
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        var selected = getSelectedTier(root);
        if (!selected) return;
        addToCart(selected, atcBtn, root);
      });
    }

    var urlTier = restoreUrlVariant(root);
    updateSelectionButton(root);
    /* Hair/Gut keep their hero only when no explicit variant was requested. */
    updateGiftEligibility(root);
    updateMainPrice(getSelectedTierInput(root) || getInitialPriceTier(root));
    if (urlTier || !root.classList.contains('knn-offer--quiz')) {
      updateGalleryMedia(getSelectedTierInput(root), false);
    }
  });

  function restoreUrlVariant(root) {
    if (!isCurrentProduct(root)) return null;
    // Keep campaign parameters intact, but let F8 shoppers choose their pack.
    if (/-8$/.test(root.dataset.productHandle)) return null;
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');
    if (!variantId) return null;
    // Match only rendered options belonging to this offer, without interpolating
    // untrusted query parameters into a CSS selector.
    var candidates = Array.from(root.querySelectorAll('[data-tier]')).filter(function (tier) {
      return tier.dataset.variant === variantId;
    });
    // A shared variant can appear in both purchase modes (Recharge bundles).
    // Only restore plans actually offered by this selector, never arbitrary IDs.
    var requestedPlan = params.get('selling_plan');
    var input = candidates.find(function (tier) {
      var list = tier.closest('.knn-offer__list[data-mode]');
      var plan = root.dataset.rechargeBundle === 'true' ? tier.dataset.sellingPlanId : tier.dataset.sellingPlan;
      return requestedPlan ? plan === requestedPlan && (!list || list.dataset.mode === 'subscribe') : list && list.dataset.mode === 'onetime';
    }) || candidates[0];
    if (!input) return null;

    var list = input.closest('.knn-offer__list[data-mode]');
    if (list) {
      root.dataset.defaultMode = list.dataset.mode;
      root.querySelectorAll('[data-mode-toggle]').forEach(function (toggle) {
        toggle.checked = toggle.value === list.dataset.mode;
      });
      updateModeVisibility(root, list.dataset.mode);
    }
    root.querySelectorAll('[data-tier]').forEach(function (tier) {
      if (tier.name !== input.name) return;
      tier.checked = tier === input;
      var label = tier.closest('label');
      if (label) label.classList.toggle('is-selected', tier.checked);
    });
    // Keep price badges and other existing selection listeners in sync as well.
    root._knnFromGallery = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    root._knnFromGallery = false;
    return input;
  }

  function isCurrentProduct(root) {
    var match = window.location.pathname.match(/\/products\/([^/]+)\/?$/);
    return !!match && decodeURIComponent(match[1]) === root.dataset.productHandle;
  }

  function syncOfferUrl(root) {
    // Featured products and quick views must not rewrite another page's URL.
    if (!isCurrentProduct(root)) return;
    var input = getSelectedTierInput(root);
    var selected = input && getSelectedTier(root);
    var url = new URL(window.location.href);
    if (selected) {
      url.searchParams.set('variant', String(selected.id));
      if (selected.sellingPlan) url.searchParams.set('selling_plan', String(selected.sellingPlan));
      else url.searchParams.delete('selling_plan');
      url.searchParams.delete('option_values');
    } else {
      url.searchParams.delete('variant');
      url.searchParams.delete('selling_plan');
    }
    if (url.href !== window.location.href) window.history.replaceState(window.history.state, '', url.href);
  }

  function updateGiftEligibility(root) {
    var input = getSelectedTierInput(root);
    // Funnel 4 (including the hair/gut 16 and 17 quiz PDPs) shows the one-bottle
    // fallback price before a tier is selected, so its two baseline gifts should
    // match that initial offer state. Once a tier is selected, normal eligibility
    // applies; other funnels still require a selected subscription tier.
    var baseUnlocked = getActiveMode(root) === 'subscribe' && (
      !!input || ['4', '16', '17'].includes(root.dataset.funnel)
    );
    root.querySelectorAll('[data-knn-base-gift]').forEach(function (gift) {
      gift.classList.toggle('is-locked', !baseUnlocked);
      gift.querySelector('.knn-pdp-free-gifts__badge').textContent = baseUnlocked ? 'FREE' : 'LOCKED';
    });
    root.querySelectorAll('[data-knn-ebook-gift]').forEach(function (gift) {
      var minimum = Number(gift.dataset.minimumBottles) || 2;
      var ebookUnlocked = getActiveMode(root) === 'subscribe' && input && Number(input.dataset.bottleCount) >= minimum;
      gift.classList.toggle('is-locked', !ebookUnlocked);
      gift.querySelector('.knn-pdp-free-gifts__badge').textContent = ebookUnlocked ? 'FREE' : 'LOCKED';
      gift.querySelector('[data-knn-gift-status]').textContent = ebookUnlocked ? '' : 'With ' + minimum + '-bottle subscription';
    });
    root.querySelectorAll('[data-knn-product-gift]').forEach(function (gift) {
      var eligible = getActiveMode(root) === 'subscribe' && input && input.dataset.variant === gift.dataset.parentVariant;
      gift.classList.toggle('is-locked', !eligible);
      gift.querySelector('.knn-pdp-free-gifts__badge').textContent = eligible ? 'FREE' : 'LOCKED';
      gift.querySelector('[data-knn-gift-status]').textContent = eligible ? '' : 'With 3-bottle subscription';
    });
    root.querySelectorAll('[data-knn-pill-gift]').forEach(function (gift) {
      var minimum = Number(gift.dataset.minimumBottles) || 3;
      var unlocked = getActiveMode(root) === 'subscribe' && input && Number(input.dataset.bottleCount) >= minimum;
      gift.classList.toggle('is-locked', !unlocked);
      gift.querySelector('.knn-pdp-free-gifts__badge').textContent = unlocked ? 'FREE' : 'LOCKED';
      gift.querySelector('[data-knn-gift-status]').textContent = unlocked ? '' : 'With ' + minimum + '-bottle subscription';
    });
  }

  document.addEventListener('slideshow:select', function (event) {
    if (!event.detail || !event.detail.userInitiated || !event.target.closest('media-gallery')) return;
    var section = event.target.closest('.shopify-section');
    var root = section && section.querySelector('.knn-offer--f4-product');
    var media = event.detail.slide && event.detail.slide.querySelector('[data-media-id]');
    if (!root || !media) return;
    var list = root.querySelector('.knn-offer__list[data-mode="' + getActiveMode(root) + '"]');
    var input = list && list.querySelector('[data-tier][data-media-id="' + media.dataset.mediaId + '"]');
    // OTP and subscription can use different photos for the same bottle count.
    // Arrow navigation visits both; select the equivalent tier without changing mode.
    if (!input && list) {
      var picturedTier = root.querySelector('[data-tier][data-media-id="' + media.dataset.mediaId + '"]');
      if (picturedTier && picturedTier.dataset.bottleCount) {
        input = list.querySelector('[data-tier][data-bottle-count="' + picturedTier.dataset.bottleCount + '"]');
      }
    }
    // Preserve purchase type; lifestyle slides have no matching offer.
    if (!input || input.checked) return;
    root._knnFromGallery = true;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    root._knnFromGallery = false;
  });

  /* Update the theme's price display to the selected variant's price + compare-at. */
  function updateMainPrice(input) {
    if (!input) return;
    var price = input.getAttribute('data-price');
    if (!price) return;
    var compare = input.getAttribute('data-compare') || '';
    var hasCompare = compare.length > 0;

    function apply(node) {
      node.querySelectorAll('.price').forEach(function (el) {
        if (el.querySelector('.price')) return;   /* skip wrapper elements */
        el.innerHTML = price;
      });
      node.querySelectorAll('.compare-at-price').forEach(function (el) { el.innerHTML = compare; });
      node.querySelectorAll('.price__regular').forEach(function (el) { el.classList.toggle('price__hidden', hasCompare); });
      node.querySelectorAll('.price__sale').forEach(function (el) { el.classList.toggle('price__hidden', !hasCompare); });
    }

    /* The theme always renders the main price inside [ref="priceContainer"]. Update
       every one on the page EXCEPT those inside product cards / related-product lists
       (so "You may also like" prices are never changed). This works regardless of
       which section the template places the price in. */
    var EXCLUDE = '.product-card, product-card, .card, .card-wrapper, product-list, .product-list, [class*="related"], [class*="recommend"], [class*="complementary"]';
    var containers = document.querySelectorAll('[ref="priceContainer"], product-price');
    containers.forEach(function (node) {
      if (node.closest(EXCLUDE)) return;
      apply(node);
    });
  }

  /* Move the product media gallery to the selected variant's image.
     This widget replaces the theme's <variant-picker>, so picking a tier never
     fires the ProductSelectEvent that assets/media-gallery.js listens for — the
     carousel would otherwise stay on the image the page was rendered with.
     Tier inputs carry data-media-id (variant.featured_media.id); each gallery
     slide wraps a .product-media[data-media-id] with the same id, so we can map
     the variant straight onto a slide index and call the slideshow's select(). */
  function updateGalleryMedia(input, animate) {
    if (!input) return;
    var mediaId = input.getAttribute('data-media-id');
    if (!mediaId) return;   /* variant has no image assigned in the admin */

    /* Only the main product gallery — never product cards or quick-add dialogs. */
    var EXCLUDE = 'product-card, quick-add-dialog, .product-card, .card-wrapper, product-list, .product-list, [class*="related"], [class*="recommend"], [class*="complementary"]';

    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.closest(EXCLUDE)) return;

      var media = gallery.querySelector('.product-media[data-media-id="' + mediaId + '"]');
      if (!media) return;   /* e.g. the gallery's "hide unselected variant media" is on */

      var slide = media.closest('slideshow-slide');
      var slideshow = slide ? slide.closest('slideshow-component') : null;

      /* Grid presentation has no carousel — just bring the image into view. */
      if (!slideshow) {
        media.scrollIntoView({ behavior: animate ? 'smooth' : 'auto', block: 'nearest' });
        return;
      }

      /* The slideshow is an ES module custom element, so it may not have been
         upgraded yet on first paint. */
      customElements.whenDefined('slideshow-component').then(function () {
        if (typeof slideshow.select !== 'function') return;
        var slides = slideshow.slides;
        if (!slides) return;
        var index = slides.indexOf(slide);
        if (index < 0) return;
        slideshow.select(index, undefined, { animate: animate !== false });
      });
    });
  }

  /* The tier input for the currently active mode/list (mirrors getSelectedTier). */
  function getSelectedTierInput(root) {
    var mode = getActiveMode(root);
    var scope = root.querySelector('.knn-offer__list[data-mode="' + mode + '"]');
    if (!scope) scope = root.querySelector('.knn-offer__list:not([hidden])');
    if (!scope) scope = root;
    return scope.querySelector('[data-tier]:checked') || (root.hasAttribute('data-require-tier-selection') ? null : scope.querySelector('[data-tier]'));
  }

  // One-bottle fallback for the price and purchase; never marks a tier selected.
  function getInitialPriceTier(root) {
    var mode = getActiveMode(root);
    var scope = root.querySelector('.knn-offer__list[data-mode="' + mode + '"]') || root.querySelector('.knn-offer__list:not([hidden])') || root;
    return Array.from(scope.querySelectorAll('[data-tier]')).find(function (tier) {
      var count = tier.dataset.bottleCount || tier.dataset.tierSize;
      // Offer labels may start with "BUY" (e.g. "BUY 1 BOTTLE" in funnel 9).
      // Match the bottle count, not an unrelated number in promotional copy.
      if (!(parseInt(count, 10) > 0)) {
        var title = tier.dataset.variantTitle || '';
        var bottles = title.match(/\b(\d+)\s*bottles?\b/i);
        count = bottles ? bottles[1] : title;
      }
      return parseInt(count, 10) === 1;
    }) || null;
  }

  function updateSelectionButton(root) {
    if (!root.hasAttribute('data-require-tier-selection')) return;
    var button = root.querySelector('[data-knn-offer-atc]');
    if (!button) return;
    var input = getSelectedTierInput(root) || getInitialPriceTier(root);
    button.disabled = !input || input.dataset.soldout === 'true';
    button.textContent = input && input.dataset.soldout === 'true' ? 'Sold out' : button.dataset.addText;
  }

  function updateModeVisibility(root, mode) {
    root.querySelectorAll('.knn-offer__list').forEach(function (list) {
      list.hidden = list.dataset.mode !== mode;
    });
    /* Anything else that swaps with the tab — funnel 4 renders a separate trust row
       per mode (purchase guarantees vs subscription benefits). Additive: funnels that
       render no panes are unaffected. */
    root.querySelectorAll('[data-knn-offer-pane]').forEach(function (pane) {
      pane.hidden = pane.dataset.knnOfferPane !== mode;
    });
    root.querySelectorAll('.knn-offer__toggle-option').forEach(function (opt) {
      opt.classList.toggle('is-active', opt.dataset.modeLabel === mode);
    });
  }

  function setMode(root, mode) {
    // The toggle is already checked when change fires; read the old visible list.
    var previousList = root.querySelector('.knn-offer__list:not([hidden])');
    var previousTier = previousList && previousList.querySelector('[data-tier]:checked');
    var previousSize = previousTier && (previousTier.dataset.tierSize || previousTier.dataset.bottleCount);
    updateModeVisibility(root, mode);
    /* Preserve pack size across purchase types, then fall back to the design default. */
    var activeList = root.querySelector('.knn-offer__list[data-mode="' + mode + '"]');
    if (activeList) {
      var tiers = activeList.querySelectorAll('[data-tier]');
      var equivalentTier = previousSize && previousSize !== '0' && Array.from(tiers).find(function (tier) {
        return (tier.dataset.tierSize || tier.dataset.bottleCount) === previousSize;
      });
      var defaultTier = equivalentTier || (root.hasAttribute('data-require-tier-selection') ? null : activeList.querySelector('[data-default-tier]') || tiers[0]);
      tiers.forEach(function (t) {
        t.checked = t === defaultTier;
        var lbl = t.closest('label');
        if (lbl) lbl.classList.toggle('is-selected', t.checked);
      });
      if (defaultTier) {
        defaultTier.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }

    /* Switching Subscribe/One-time changes the active tier → update price + image. */
    updateSelectionButton(root);
    updateGiftEligibility(root);
    updateMainPrice(getSelectedTierInput(root) || getInitialPriceTier(root));
    updateGalleryMedia(getSelectedTierInput(root), true);
    syncOfferUrl(root);
  }

  function getActiveMode(root) {
    var checked = root.querySelector('[data-mode-toggle]:checked');
    return checked ? checked.value : (root.dataset.defaultMode || 'subscribe');
  }

  function getSelectedTier(root) {
    var mode = getActiveMode(root);
    var input = getSelectedTierInput(root) || getInitialPriceTier(root);
    if (!input || input.dataset.soldout === 'true') return null;
    /* Recharge selling plan for this variant, when the merchant has attached one
       (data-selling-plan renders empty otherwise). Without it the line is added as
       a plain one-time purchase — at the subscription price, with no recurring
       order — so the plan MUST travel with the variant into /cart/add.js. */
    var selectedList = input.closest('.knn-offer__list[data-mode]');
    var purchaseMode = selectedList ? selectedList.dataset.mode : mode;
    var plan = parseInt(input.dataset.sellingPlan, 10);
    if (purchaseMode === 'onetime') plan = NaN;
    if (root.dataset.rechargeBundle === 'true') {
      plan = purchaseMode === 'subscribe' ? parseInt(input.dataset.sellingPlanId, 10) : NaN;
      if (purchaseMode === 'subscribe' && isNaN(plan)) {
        console.warn('[KNN offer] No unambiguous monthly selling plan for bundle variant ' + input.dataset.variant);
        return null;
      }
    }
    return {
      id: parseInt(input.dataset.variant, 10),
      purchaseMode: purchaseMode,
      isRechargeBundle: root.dataset.rechargeBundle === 'true',
      quantity: root.dataset.rechargeBundle === 'true' ? 1 : (parseInt(input.dataset.quantity, 10) || 1),
      sellingPlan: isNaN(plan) ? null : plan,
      sellingPlanId: isNaN(plan) ? null : plan,
      /* Label of the chosen tier ("3 Bottles"), for the ATC tracking payload. */
      variantTitle: input.dataset.variantTitle || ''
    };
  }

  /* Resolve the line items for this selection. Returns a promise so the Free Gift
     flows — which have to read the cart before deciding — share one code path with
     the plain add. Resolving to null means "nothing to add" (the Supergreens 6-bottle
     bundle is already at its cap of 2). */
  function buildItems(sel) {
    var fg = window.KNNFreeGift;

    var plainItem = { id: sel.id, quantity: sel.quantity };
    /* Only send selling_plan when the variant actually has one — passing null/0
       makes Shopify reject the add. */
    if (sel.sellingPlan) plainItem.selling_plan = sel.sellingPlan;
    if (sel.isRechargeBundle) return Promise.resolve([plainItem]);

    var config = fg && fg.getFreeGiftConfig();
    if (!config || !config.enabled) return Promise.resolve([plainItem]);

    /* The F4 gift catalog is shared with funnels 16/17. Those rules describe the
       subscription tiers, but a malformed or stale variant mapping must never make
       an OTP click add the associated ebooks or physical gifts. Trust the selected
       purchase-mode list as the source of truth and send exactly the chosen product. */
    if (sel.purchaseMode === 'onetime') return Promise.resolve([plainItem]);

    /* Funnel 4: only the configured Subscribe & Save 3 Bottles variant matches, so
       every other tier falls through to the single plain line. The gift comes back
       WITHOUT a selling plan — it ships with the first order and never renews. */
    if (config.flow === 'old_funnel_subscription_gift') {
      return fg.fetchCartJson()
        .then(function (cart) {
          var items = fg.buildOldFunnelSubscriptionGiftItems({
            config: config,
            variantId: sel.id,
            quantity: sel.quantity,
            sellingPlanId: sel.sellingPlan
          });
          /* Never stack a second gift for a parent that already has one. */
          return fg.dropDuplicateGiftItems(cart, items);
        })
        .catch(function () {
          return [plainItem];
        });
    }

    /* Supergreens Funnel 6: cart-aware (dedupe + the 6_plus_2 quantity cap). A variant
       with no rule returns null, which keeps the untouched single-line behaviour. */
    if (config.flow === 'otp_gift') {
      return fg.fetchCartJson()
        .then(function (cart) {
          var built = fg.buildOtpGiftItems(cart, {
            config: config,
            variantId: sel.id,
            quantity: sel.quantity,
            sellingPlanId: sel.sellingPlan
          });
          if (!built) return [plainItem];
          if (built.maxReached) return null;
          return built.items;
        })
        .catch(function () {
          return [plainItem];
        });
    }

    return Promise.resolve([plainItem]);
  }

  /* ---- Add to Cart tracking (GTM + TikTok) ----
     Ported from pushGTMaddToCart.

     Two deliberate departures from that implementation, both agreed before porting:

       event name  it has two competing patterns — a bare product handle from the main
                   ATC button, and `product-<handle>-addtocart` from the newer free-gift
                   path. We use the latter for every add.
       convCode    it computes `subs ? 'subscription' : 'product'` but passes the STRING
                   "product" for one-time adds, which is truthy — so every one-time add
                   there reports as 'subscription'. Here the flag is the selling plan
                   itself, so a one-time add correctly reports 'product'.

     Never let a tracking failure break the add: the caller has already put the line in
     the cart by the time this runs. */
  function trackAddToCart(root, sel, added) {
    try {
      var handle = (root && root.dataset.productHandle) || '';
      if (!handle) return;

      /* "3 Bottles" -> "3-bottles", matching pushGTMaddToCart's slug. */
      var label = sel && sel.variantTitle ? sel.variantTitle : '';
      var productName = label ? label.trim().toLowerCase().replace(/\s+/g, '-') : '';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'product-' + handle + '-addtocart',
        productName: productName,
        convCode: sel && sel.sellingPlan ? 'subscription' : 'product'
      });

      /* TikTok, as the source does. Guarded on ttq because the pixel is an app embed
         that a merchant can switch off — the source instead guarded on a product-title
         element from its own theme, which does not exist here. */
      if (typeof window.ttq !== 'undefined' && window.ttq && typeof window.ttq.track === 'function') {
        var title = (root.dataset.productTitle || (added && (added.product_title || added.title)) || '').trim();
        window.ttq.track('AddToCart', {
          content_id: productName ? title + ' ' + productName : title,
          content_type: 'product'
        });
      }
    } catch (err) {
      /* eslint-disable-next-line no-console */
      console.warn('[knn-offer] ATC tracking failed:', err);
    }
  }

  function addToCart(sel, btn, root) {
    /* Ignore duplicate invocations while the first cart request is in flight. */
    if (!btn || btn.disabled) return;

    var addText     = btn.dataset.addText     || btn.textContent;
    var loadingText = btn.dataset.loadingText || '...';

    btn.disabled    = true;
    btn.textContent = loadingText;

    buildItems(sel)
      .then(function (items) {
        if (!items || !items.length) return null;

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) {
            return r.json().then(function (e) {
              throw new Error(e.description || 'Could not add item to cart.');
            });
          }
          return r.json();
        });
      })
      .then(function (result) {
        if (!result) return;
        var added = result.items ? result.items[0] : result;
        /* Only after the line is really in the cart — an add that 422s (sold out, or a
           bundle at its cap) must not report as a conversion. */
        trackAddToCart(root, sel, added);
        window._learnq = window._learnq || [];
        window._learnq.push(['track', 'Added to Cart', {
          ProductID: added.product_id,
          Name: added.product_title || added.title,
          VariantID: added.variant_id,
          Quantity: added.quantity,
          Price: added.price / 100
        }]);
        /* Hand off to the KNN mini cart: it refreshes its body and opens. */
        document.dispatchEvent(new CustomEvent('knn:cart:added', { bubbles: true }));
      })
      .catch(function (err) {
        /* eslint-disable no-console */
        console.error('[knn-offer] add to cart error:', err.message);
        window.alert(err.message);
      })
      .finally(function () {
        btn.disabled    = false;
        btn.textContent = addText;
        updateSelectionButton(root);
      });
  }

  /* Catch-all: any tier/offer selection anywhere updates the main price + gallery.
     Delegated at the document level so it works for every funnel/design regardless
     of per-widget binding (and survives re-rendered markup). */
  document.addEventListener('change', function (e) {
    var input = e.target.closest ? e.target.closest('[data-tier]') : null;
    if (!input) return;
    updateMainPrice(input);
    updateGalleryMedia(input, true);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    /* Product cards and recommendation lists carry their own prices — a bundle
       selection on the main product must never rewrite those. */
    var EXCLUDE =
      '.product-card, product-card, .card, .card-wrapper, product-list, .product-list,' +
      '[class*="related"], [class*="recommend"], [class*="complementary"]';

    function updateBadges(variantId, selectedTier) {
      if (!variantId) return;

      document.querySelectorAll('[data-discount-badge]').forEach(function (badge) {
        if (badge.closest(EXCLUDE)) return;

        var map;
        try {
          map = JSON.parse(badge.getAttribute('data-discount-map') || '{}');
        } catch (e) {
          return;
        }

        var entry = map[String(variantId)];
        if (selectedTier && selectedTier.hasAttribute('data-discount-percent')) {
          var tierPercent = parseInt(selectedTier.getAttribute('data-discount-percent'), 10) || 0;
          entry = tierPercent > 0 ? {
            p: tierPercent,
            a: selectedTier.getAttribute('data-discount-amount') || ''
          } : null;
        }
        var template = badge.getAttribute('data-discount-badge-template');

        if (!entry || !entry.p || !template) {
          badge.hidden = true;
          badge.textContent = '';
          return;
        }

        badge.hidden = false;
        badge.textContent = template.replace('__PERCENT__', entry.p).replace('__AMOUNT__', entry.a);
      });
    }

    /* The bundle/tier selectors expose the chosen variant id as the radio value, and
       delegate at document level so re-rendered markup keeps working. Listening to the
       same signal keeps the badge in step without depending on the offer block's own
       price-writing code. */
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var tier = target.closest('[data-tier], input[name="id"], select[name="id"]');
      if (tier && tier.value) updateBadges(tier.value, tier.matches('[data-tier]') ? tier : null);

      var modeToggle = target.closest('[data-mode-toggle]');
      if (modeToggle) {
        var offer = modeToggle.closest('[data-knn-offer]');
        var activeList = offer && offer.querySelector('.knn-offer__list[data-mode="' + modeToggle.value + '"]');
        if (!activeList) return;

        var activeTier = activeList.querySelector('[data-tier]:checked') || Array.from(activeList.querySelectorAll('[data-tier]')).find(function (candidate) {
          return parseInt(candidate.dataset.bottleCount || candidate.dataset.tierSize, 10) === 1;
        }) || activeList.querySelector('[data-tier]');

        if (activeTier) updateBadges(activeTier.value, activeTier);
      }
    });

    /* On load the offer block forces the price to the checked tier, or to the first one
       when nothing is preselected. The badge has to resolve the variant the same way,
       otherwise a ?variant= URL or a sold-out first variant leaves it describing a
       different variant than the price beside it. */
    function syncToInitialTier() {
      var scope = document.querySelector('.knn-offer__list:not([hidden])') || document;
      var input = scope.querySelector('[data-tier]:checked') || Array.from(scope.querySelectorAll('[data-tier]')).find(function (candidate) {
        return parseInt(candidate.dataset.bottleCount || candidate.dataset.tierSize, 10) === 1;
      }) || scope.querySelector('[data-tier]');
      if (input && input.value) updateBadges(input.value, input);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncToInitialTier);
    } else {
      syncToInitialTier();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
